import { eventChannel } from 'redux-saga';
import Notifier from '../../utils/pdsV6';
import { cashInPriceChange, eventInPlayChange, connected, connectionError } from '../pds/actions';

const connectionDetails = {
  wsURL: api_config.pds_api_v6
};

export default (topics) => eventChannel(emitter => {
  const notifier = new Notifier();

  const disconnectHandler = () => {
    emitter(connectionError());
    notifier.connect(connectionDetails);
  };

  notifier.on('connect', () => {
    notifier.on('cashInPriceChange', () => emitter(cashInPriceChange()));
    notifier.on('eventInPlayChange', (eventInfo) => emitter(eventInPlayChange(eventInfo)));
    notifier.on('timeout', ({ event, market, selection }) => {
      if (event && !market && !selection) {
        emitter(eventInPlayChange({
          eventId: event,
          isPreMatch: false,
          isInPlay: false,
          isPostMatch: true
        }));
      }
    });
    topics.forEach(topic => notifier.add(topic));
    emitter(connected());
  });
  notifier.on('disconnect', disconnectHandler);
  notifier.on('error', disconnectHandler);
  notifier.connect(connectionDetails);

  return () => {
    notifier.off('connect');
    notifier.off('disconnect');
    notifier.off('error');
    notifier.removeAll();
    notifier.disconnect();
  };
});
